/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'owl.carousel2';
import { Fancybox } from '@fancyapps/ui';

import Isotope from 'isotope-layout';

$(() => {
  /**
   * Scroll position for menu
   */
  var lastScrollTop = 0;
  $(window).scroll(function () {
    var st = $(this).scrollTop();

    if (st > 30) {
      $('header').addClass('scrolled');

      if (st > lastScrollTop) {
        $('header').addClass('hideSubmenu');
      } else {
        $('header').removeClass('hideSubmenu');
      }
    } else {
      $('header').removeClass('scrolled');
      $('header').removeClass('hideSubmenu');
    }

    lastScrollTop = st;
  });

  /**
   * Scroll achnor
   */
  $(function () {
    $('a[href*="#"]:not([href="#"])').on('click', function () {
      if (
        location.pathname.replace(/^\//, '') ==
        this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
            'linear'
          );
          return false;
        }
      }
    });
  });

  /**
   * Owl carousel - full
   */

  if ($('.carousel').length) {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/player_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    function toggleOwlVideos() {
      if ($('.owl-item .item-video iframe').length) {
        $('.owl-item .item-video iframe').each(function () {
          if ($(this).closest('.owl-item').hasClass('active')) {
            this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
          } else {
            this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            this.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*')
          }
        });
      }

      var currentSlide = $(".owl-item.active");
      var id = currentSlide.find('.video').attr('id');

      if (typeof id === 'undefined') {
        var newId = 'player-' + Math.floor(Math.random() * 10000);
        id = newId;
        currentSlide.find('.video').attr('id', newId);
      }

      var videoID = currentSlide.find('.video').attr('data-video');
      if (typeof videoID === 'undefined') {
        return;
      }

      if ($('#' + id).hasClass('loaded')) {
        return;
      }

      $('#' + id).addClass('loaded');

      //var player1;
      new YT.Player(id, {
        playerVars: { 'rel': 0, 'loop': 1, 'autoplay': 1, 'controls': 0, 'autohide': 1, 'showinfo': 0, 'wmode': 'opaque', 'disablekb': 1 },
        videoId: videoID,
        suggestedQuality: 'hd720',
        events: {
          'onReady': onPlayerReady
        }
      });
    }

    function onPlayerReady(event) {
      event.target.mute();
      event.target.playVideo();
      event.target.mute();
      event.target.setVolume(0);
    }

    function owlHomeCarouselInit() {
      $('.carousel').trigger('refresh.owl.carousel');

      setTimeout(function () {
        $('.carousel').trigger('refresh.owl.carousel');
      }, 1500);
    }

    var changedHomeSlider = false;
    var owl = $('.carousel').owlCarousel({
      //loop: true,
      rewind: true,
      margin: 1,
      nav: false,
      items: 1,
      autoplay: false,
      video: true,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      lazyLoad: true,
      dotData: true,
      dotsData: true,
      autoplayTimeout: 6000,
      onInitialized: owlHomeCarouselInit,
    });

    var waitForNewSlider = false;
    var waitingSliderTimeout;
    owl.on('changed.owl.carousel', function (event) {
      // play video?
      setTimeout(toggleOwlVideos, 0);

      // set autoplay
      if (waitForNewSlider == true && typeof waitingSliderTimeout !== 'undefined') {
        clearTimeout(waitingSliderTimeout);
      }

      var current = event.item.index;
      var delay = $(event.target).find(".owl-item").eq(current).find('.item').attr('data-delay');

      waitingSliderTimeout = setTimeout(function () {
        waitForNewSlider = true;
        owl.trigger('next.owl.carousel');
      }, (typeof delay !== 'undefined' ? delay : 5000));
    });

    window.onload = (event) => {
      $('.carousel').trigger('refresh.owl.carousel');
    }

    /*setInterval(function() {
      $('.carousel').trigger('refresh.owl.carousel');
    }, 5000);*/

    /*var triggerOpenCalled = false;
    $('body').bind('mousewheel', function (e) {
      if (e.originalEvent.wheelDelta / 120 > 0) {
        //console.log('scrolling up !');
      }
      else {
        if (triggerOpenCalled == true) {
          return;
        }
        $('.navbar-toggler').trigger('click');
        triggerOpenCalled = true;
      }
    });*/


    var lastY;
    $(document).bind('touchmove', function (e) {
      var currentY = e.originalEvent.touches[0].clientY;
      console.log(currentY);
      if (currentY > lastY) {
        // moved down
      } else if (currentY < lastY) {
        if (triggerOpenCalled == true) {
          return;
        }
        $('.navbar-toggler').trigger('click');
        triggerOpenCalled = true;
      }
      lastY = currentY;
    });
  }

  /**
   * Owl carousel 
   */

  if ($('.process-points__carousel').length) {

    function owlProcessInit(event) {
      var current = event.item.index;
      var total = event.item.count;

      if (current != (total - 1)) {
        $('section.process-points .process-points__carousel-holder .prev-arrow').fadeIn().css('display', 'flex');
      } else {
        $('section.process-points .process-points__carousel-holder .prev-arrow').fadeOut();
      }

      if (current != 0) {
        $('section.process-points .process-points__carousel-holder .next-arrow').fadeIn().css('display', 'flex');
      } else {
        $('section.process-points .process-points__carousel-holder .next-arrow').fadeOut();
      }
    }

    var OwlProcess = $('.process-points__carousel').owlCarousel({
      loop: false,
      margin: 1,
      nav: false,
      items: 1,
      autoplayTimeout: 2500,
      smartSpeed: 200,
      autoplayHoverPause: true,
      onInitialized: owlProcessInit
    });
    OwlProcess.on('changed.owl.carousel', function (event) {
      var current = event.item.index;
      var total = event.item.count;

      if (current != (total - 1)) {
        $('section.process-points .process-points__carousel-holder .prev-arrow').fadeIn().css('display', 'flex');
      } else {
        $('section.process-points .process-points__carousel-holder .prev-arrow').fadeOut();
      }

      if (current != 0) {
        $('section.process-points .process-points__carousel-holder .next-arrow').fadeIn().css('display', 'flex');
      } else {
        $('section.process-points .process-points__carousel-holder .next-arrow').fadeOut();
      }
    });

    $('section.process-points .process-points__carousel-holder .prev-arrow').on('click', function () {
      OwlProcess.trigger('next.owl.carousel');
    });
    $('section.process-points .process-points__carousel-holder .next-arrow').on('click', function () {
      OwlProcess.trigger('prev.owl.carousel');
    });

    $('.process-points .jumpTo').on('mouseenter', function () {
      var index = parseInt($(this).attr('data-index'));
      console.log(index);
      $('.process-points__carousel').trigger('to.owl.carousel', index);
    });
  }

  /**
   * set team name height
   */
  function resizeName() {
    if ($('.team').length) {
      $('.team').find('.profile-block .name').css('min-height', '');
      $('.team .row.mb').each(function () {
        var parent = $(this);
        var minHeight = 0;

        parent.find('.profile-block .name').each(function () {
          if ($(this).height() > minHeight) {
            minHeight = $(this).height();
          }
        });

        parent.find('.profile-block .name').css('min-height', minHeight + 'px');
      });
    }
  }

  resizeName();
  $(window).on('resize', function() {
    resizeName();
  });

  if( $('#technologie').length ) {
    var currentScroll = $(window).scrollTop();
    var elementScroll = ($('#technologie').offset().top - $(window).height());

    if( currentScroll > elementScroll ) {
      $('nav ul #menu-item-692').addClass('current-menu-item');
      $('nav ul #menu-item-69').removeClass('current-menu-item');
    } else {
      $('nav ul #menu-item-69').addClass('current-menu-item');
      $('nav ul #menu-item-692').removeClass('current-menu-item');
    }

    $(window).on('scroll', function() {
      var currentScroll = $(window).scrollTop();
      var elementScroll = ($('#technologie').offset().top - $(window).height());

      if( currentScroll > elementScroll ) {
        $('nav ul #menu-item-692').addClass('current-menu-item');
        $('nav ul #menu-item-69').removeClass('current-menu-item');
      } else {
        $('nav ul #menu-item-69').addClass('current-menu-item');
        $('nav ul #menu-item-692').removeClass('current-menu-item');
      }
    });

  }

});
